import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCheckCircle } = FiIcons;

export default function Step4Success({ onAccept, amount, choice, tradeDetails }) {
  const isTradeIn = choice === 'trade';

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }} animate={{ opacity: 1, scale: 1 }}
      className="card-premium text-center border-green-500 border-2"
    >
      <div className="flex justify-center mb-6">
        <SafeIcon icon={FiCheckCircle} className="w-20 h-20 text-green-500" />
      </div>

      <h2 className="text-3xl font-extrabold text-slate-900 mb-2">Offer Ready!</h2>
      <p className="text-xl text-slate-600 mb-8">
        {isTradeIn
          ? `Your trade-in covers your $${amount} balance. We'll handle the payoff directly with your carrier.`
          : `A lender has approved financing for your $${amount} carrier payoff.`}
      </p>

      <div className="bg-slate-50 rounded-xl p-6 mb-8 text-left border border-slate-100">
        <h4 className="font-semibold text-slate-900 mb-4 border-b pb-2">
          {isTradeIn ? 'Trade-In Summary' : 'Financing Summary'}
        </h4>
        {isTradeIn ? (
          <>
            <div className="flex justify-between mb-2">
              <span className="text-slate-600">Device:</span>
              <span className="font-medium">{tradeDetails?.brand} {tradeDetails?.model}</span>
            </div>
            <div className="flex justify-between mb-2">
              <span className="text-slate-600">Condition:</span>
              <span className="font-medium capitalize">{tradeDetails?.condition}</span>
            </div>
            <div className="flex justify-between">
              <span className="text-slate-600">Applied to Carrier Balance:</span>
              <span className="font-medium text-green-600">${amount}</span>
            </div>
          </>
        ) : (
          <>
            <div className="flex justify-between mb-2">
              <span className="text-slate-600">Amount to Carrier:</span>
              <span className="font-medium">${amount}</span>
            </div>
            <div className="flex justify-between mb-2">
              <span className="text-slate-600">Rate:</span>
              <span className="font-medium text-slate-700">Set by lender — shown at sign</span>
            </div>
            <div className="flex justify-between">
              <span className="text-slate-600">Estimated Payoff:</span>
              <span className="font-medium">Same Day</span>
            </div>
          </>
        )}
      </div>

      <button onClick={onAccept} className="w-full btn-primary py-4 text-lg bg-green-600 hover:bg-green-700">
        Accept & Pay Carrier
      </button>
      <p className="mt-4 text-xs text-slate-400">Final terms set by lending partner. Review before signing.</p>
    </motion.div>
  );
}